import $ from 'jquery';

// Slidescroll.js
// Creates scrolling effect with same-page anchor links

$(() => {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      try {
        let target = $(this.hash);
        target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
        const offset = target.attr('data-offset');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - (offset ? offset : 0),
          }, 500);
          return false;
        }
      } catch (e) {
        return true;
      }
    }
  });
});
